module.exports = __webpack_public_path__ + "static/media/visa-icon.dd131141.svg";